module.exports = __webpack_public_path__ + "img/coming-soon.e97f550b.svg";